import { useHistory } from 'react-router-dom';
import PATHS from '../../../routes/routes.const';
import { useIsRachelPage } from './useIsRachelPage';

export const useRachelPageNavigation = () => {
  const history = useHistory();
  const isOnPage = useIsRachelPage();

  const canGoBack = history.action === 'PUSH';

  const openPage = () => {
    if (isOnPage) {
      return;
    }

    history.push(PATHS.main.rachel.path);
  };

  const leavePage = () => {
    if (history.action === 'PUSH') {
      history.goBack();
      return;
    }

    history.replace(PATHS.main.home.path);
  };

  return { openPage, leavePage, canGoBack };
};
